import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring, AnimatePresence } from "framer-motion";
import { useDesktop } from "@/lib/useDesktop";

const INTERACTIVE = "[data-cursor-text]";

export default function CustomCursor() {
  const isDesktop = useDesktop();
  const [label, setLabel] = useState("");

  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const bx = useSpring(x, { stiffness: 350, damping: 28, mass: 0.4 });
  const by = useSpring(y, { stiffness: 350, damping: 28, mass: 0.4 });

  useEffect(() => {
    if (!isDesktop) return;
    const move = (e) => { x.set(e.clientX); y.set(e.clientY); };
    const over = (e) => {
      const el = e.target.closest ? e.target.closest(INTERACTIVE) : null;
      setLabel(el ? el.getAttribute("data-cursor-text") || "" : "");
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [isDesktop, x, y]);

  if (!isDesktop) return null;
  const active = !!label;

  return (
    <>
      <motion.div
        className="cursor-dot"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
        animate={{ scale: active ? 0 : 1 }}
        transition={{ type: "spring", stiffness: 400, damping: 25 }}
      />
      <motion.div
        className="fixed top-0 left-0 z-[9999] rounded-full flex items-center justify-center pointer-events-none bg-black text-white"
        style={{ x: bx, y: by, translateX: "-50%", translateY: "-50%" }}
        animate={{ width: active ? 72 : 0, height: active ? 72 : 0, opacity: active ? 1 : 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 24 }}
      >
        <AnimatePresence mode="popLayout">
          {active && (
            <motion.span
              key={label}
              initial={{ opacity: 0, scale: 0.7 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.7 }}
              transition={{ duration: 0.16 }}
              className="font-mono uppercase tracking-[0.12em] text-[10px]"
            >
              {label}
            </motion.span>
          )}
        </AnimatePresence>
      </motion.div>
    </>
  );
}
